(function () {

    'use strict';

    angular.module('iplusjs.utils.objectType', [
        'iplusjs.utils.misc',
        'iplusjs.utils.schluesselWerte'
    ])
    .service('ObjectTypeUtilsService', ObjectTypeUtilsService);

    ObjectTypeUtilsService.$inject = [
        'MiscUtilsService',
        'SchluesselWerteUtilsService'
    ];
    function ObjectTypeUtilsService(MiscUtilsService, SchluesselWerteUtilsService) {
        var that = this,
            objectTypes = {
                kommunikationsmedium: {
                    properties: 'art wert kommunikationswegId'.split(' '),
                    artType: 'KOMMUNIKATIONSWEGART'
                },
                schluesselwert: {
                    type: 'SCHLUESSELWERT'
                },
                wertBezeichnung: {
                    properties: 'wert bezeichnung'.split(' ')
                },
                valueId: {
                    properties: 'value id'.split(' ')
                }
            };

        that.create = create;
        function create(type, obj) {
            var objectType = {};

            if (MiscUtilsService.isAtLeastOneEmpty(type, obj) || !objectTypes[type]) {
                return objectType;
            }

            if (objectTypes[type].type === 'SCHLUESSELWERT') {
                return SchluesselWerteUtilsService.create(obj.typ, obj.wert);
            }

            objectTypes[type].properties.forEach(function (prop) {
                if (prop === 'art') {
                    objectType[prop] = SchluesselWerteUtilsService.create(objectTypes[type].artType, obj[prop]);
                } else {
                    if (obj.hasOwnProperty(prop)) {
                        objectType[prop] = obj[prop];
                    } else if (prop) {
                        objectType[prop] = null;
                    }
                }
            });

            return objectType;
        }
    }
})();
